exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mark-component{display:inline-block;min-width:113px;width:113px;border-radius:5px}.mark-component__text{font-size:14px;font-weight:700;padding:2px 6px;text-align:center}.mark-component .corners{display:none;height:8px}.mark-component .corners__first,.mark-component .corners__last{width:50%}body[dir=rtl] .mark-component .corners{flex-direction:row-reverse}", ""]);

// exports
